import React, {useEffect, useState} from "react";
import CreatableSelect from "react-select/creatable";

// Email validation
const isValidEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
};

const EmailTagInput = ({
                           suggestions = [],
                           onChange,
                           suggestSomething,
                           styles = {},
                           placeholder = "Enter email addresses...",
                           defaultEmails = []
                       }) => {
    const [emails, setEmails] = useState([]);
    const [inputValue, setInputValue] = useState("");


    useEffect(() => {
        const validEmails = defaultEmails
            .map((email) => {
                if (typeof email === "string") {
                    return isValidEmail(email)
                        ? {label: email, value: email}
                        : null;
                } else if (email?.value && isValidEmail(email.value)) {
                    return email;
                }
                return null;
            })
            .filter(Boolean);

        setEmails(validEmails);
    }, [defaultEmails]);


    const handleChange = (value) => {
        setEmails(value || []);
        if (onChange) {
            onChange(value.map((v) => v.value));
        }
    };

    const handleInputChange = (value) => {
        setInputValue(value);
        suggestSomething(value)
    };

    const handleKeyDown = (event) => {
        if (!inputValue)
            return;

        if (
            event.key === "Enter" ||
            event.key === "Tab" ||
            event.key === "," ||
            event.key === " "
        ) {
            event.preventDefault();
            const email = inputValue.trim();

            if (isValidEmail(email)) {
                const exists = emails.some((e) => e.value === email);
                if (!exists) {
                    const newEmail = {label: email, value: email};
                    const updatedEmails = [...emails, newEmail];
                    setEmails(updatedEmails);
                    setInputValue("");
                    if (onChange) {
                        onChange(updatedEmails.map((v) => v.value));
                    }
                } else {
                    setInputValue("");
                }
            }
        }
    };

    const handleBlur = () => {
        console.log("handling blur")
        if (!inputValue) return;

        const email = inputValue.trim();
        if (isValidEmail(email)) {
            const exists = emails.some((e) => e.value === email);
            if (!exists) {
                const newEmail = {label: email, value: email};
                const updatedEmails = [...emails, newEmail];
                setEmails(updatedEmails);
                setInputValue("");
                if (onChange) {
                    onChange(updatedEmails.map((v) => v.value));
                }
            } else {
                setInputValue("");
            }
        }
    };

    return (
        <CreatableSelect
            isMulti
            options={suggestions}
            value={emails}
            inputValue={inputValue}
            onChange={handleChange}
            onInputChange={handleInputChange}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
            placeholder={placeholder}
            styles={styles}
            components={{DropdownIndicator: null}}
            isValidNewOption={() => false}
        />
    );
};

export default EmailTagInput;
